import React, { useState } from 'react';

import NumberInput from 'fantastic/components/common/NumberInput';
import utils from 'fantastic/lib/utils';

const { px } = utils;

const Padding = (props) => {
  const [ padding, setPadding] = useState(props.padding.value);

  const onChange = (value) => {
    const { onChange, padding: { field } } = props;
    onChange(field, px(value));
  };

  const label = props.label || i18n.t('indent');
  const { max, min } = props;
  return (
    <div className="form-group">
      <label>{label}</label>
      <NumberInput value={padding.replace('px', '')} onChange={onChange} max={max} min={min}/>
    </div>
  );
};

export default Padding;
